<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div @click="modalClick" :ref="`filerModal-${modalName}`" :class="isRight ? 'modal-body right' : 'modal-body'">
    <div
        title="Close"
        class="close_filter"
        @click="hideModal($event, modalName)"
    >
      <v-icon size="24">mdi-close-circle</v-icon>
    </div>
    <div class="filter-body">
      <form
          :id="formName"
          @submit.prevent="submitFilter"
      >
        <div class="section-block">
          <input type="text" class="filter-search" placeholder="  Filter by..." v-model="search">
        </div>
        <span
            @click="selectAllToggle"
            class="text-filter-list select-deselect-all"
        >
            Select / Deselect All
        </span>
        <div class="section-block filters-list">
          <v-progress-linear v-show="prelodaer"
                             indeterminate
          ></v-progress-linear>
          <div
              class="filterCheckBoxGroup"
          >
            <div v-for="data in filteredData">
              <div v-if="data && data.length <= 24">
                <label>
                  <input type="checkbox" :id="data" :value="data" v-model="selectedFilters">
                  {{ data }}
                </label>
              </div>
              <div v-else-if="data && data.length > 24">
                <label>
                  <input type="checkbox" :id="data" :value="data" v-model="selectedFilters">
                  {{ data.substring(0, 24) + "..." }}
                </label>
              </div>
              <div v-else>
                <label>
                  <input type="checkbox" :id="data" :value="data" v-model="selectedFilters">
                  {{ data }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="flex jcsb btn_wrap">
          <button class="button-cancel" @click="cancelAllFilters">Cancel all filters</button>
          <button class="button-filter" type="submit" :form="formName">Filter</button>
        </div>

        <div class="section-block selectedFilters">
          <div
              :title=" filter "
              v-for="filter in selectedFilters"
          >
            <a
                class="btn-link custom-button"
                @click="deleteFilter(filter)"
            >
              <v-icon color="#fff" size="20">mdi-close-circle-outline</v-icon>
            </a>
            <span v-if="!isNaN(filter)">
              {{ filter }}
            </span>
            <span v-else>
              {{ filter.length <= 14 ? filter : filter.substring(0, 15) + "..." }}
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    storeData: Array,
    dataProperty: String,
    formName: String,
    modalName: String,
    usedFilters: Array,
    isShown: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.setPosition)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setPosition)
  },
  computed: {
    filteredData() {
      if (!this.data) return [];
      if (!this.search) {
        return this.nonEmptyColumns.includes(this.formName)
                ? [...this.data.map(value => value[this.dataProperty]).filter(Boolean)]
                : ['Empty', ...this.data.map(value => value[this.dataProperty]).filter(Boolean)]
      }
      const filteredData = this.data.filter(value => {
        if (!value[this.dataProperty]) return
        return value[this.dataProperty].toLowerCase().includes(this.search.toLowerCase())
      });
      return filteredData.map(value => value[this.dataProperty]);
    },
  },
  watch: {
    selectedFilters() {
      this.$emit(`${this.modalName}FilterChange`, this.selectedFilters)
      this.$emit('filterChange', this.selectedFilters)
    },
    search() {
      if (!this.awaitingSearch) {
        const timeout = this.search.length > 0 ? 1500 : 0;
        setTimeout(() => {
          this.$emit(`${this.modalName}Search`, this.search);
          this.$emit(`dataSearch`, this.search);
          this.prelodaer = true;
          this.awaitingSearch = false;
        }, timeout);
      }
      this.awaitingSearch = true;
    },
    storeData() {
      this.prelodaer = false;
      this.data = this.storeData;
    },
    isShown() {
      this.setPosition()
    }
  },
  methods: {
    modalClick($event) {
      $event.stopPropagation();
    },
    setPosition() {
      if(this.isShown) {
        if (this.$refs[`filerModal-${this.modalName}`]) {
          const left = this.$refs[`filerModal-${this.modalName}`].getBoundingClientRect().left;
          this.isRight = left + 350 > window.innerWidth
        }
      } else {
        this.isRight = false;
      }
    },
    cancelAllFilters() {
      this.selectedFilters = []
    },
    hideModal(event, modal) {
      event.preventDefault()
      this.$emit('hideModal', modal)
    },
    submitFilter() {
      this.$emit(this.modalName + 'Filter')
      this.$emit('submitFilter')
    },
    deleteFilter(filter) {
      let index = this.selectedFilters.indexOf(filter)
      this.selectedFilters.splice(index, 1)
    },
    selectAllToggle() {
      this.isSelectedAll = !this.isSelectedAll;
      if (this.isSelectedAll) {
        this.selectedFilters.length = 0;
        this.selectedFilters = [...this.filteredData];
      } else {
        this.cancelAllFilters();
      }
    }
  },
  data() {
    return {
      data: [],
      selectedFilters: this.usedFilters,
      search: '',
      isRight: false,
      awaitingSearch:false,
      prelodaer: false,
      isSelectedAll: false,
      nonEmptyColumns:['id','status', 'type', 'currencyId']
    }
  }
}
</script>

<style lang="sass">
.modal-data
  position: absolute

.select-deselect-all
  &:hover
    cursor: pointer


.modal-content
  position: absolute !important

.modal-body
  width: 360px
  height: auto
  background-color: #E3EEF4
  border: 2px solid #ACC3CF
  border-radius: 4px
  position: absolute
  top: 15px
  z-index: 1
  &.right
    right: 0
  .close_filter
    cursor: pointer
    position: absolute
    top: 0
    left: 0
    i
      color: var(--v-primary-base)

  .selectedFilters
    display: flex
    flex-direction: row
    flex-wrap: wrap

    div
      margin: 0px 5px 5px 0
      padding: 0 2px
      width: 145px
      height: 23px
      color: #ffffff
      background-color: #3A3852
      border-radius: 4px
      overflow: hidden
      a
        margin: 0 !important
        padding: 0 !important
        &:hover
          color: transparent

  .filter-body
    padding: 0 0 1.5rem 0 !important

  h1
    font-size: 28px
    text-align: left

  form
    margin: 0 auto
    width: 300px
    text-transform: none

  .section-block
    margin-top: 1rem

  span
    font-family: "Proxima Nova"
    font-weight: 600
    font-size: 12px
    line-height: 20px
    letter-spacing: 0.3px
    color: #7F98A5

  .text-filter-list
    margin-top: 12px
    display: block
    //margin-top: 1rem
    text-align: left

  .filters-list
    margin-top: 0.4rem !important
    width: 300px
    height: 153px
    background-color: #ffffff
    border-radius: 4px
    overflow: auto

    .filterCheckBoxGroup
      display: flex
      flex-direction: column
      align-items: flex-start
      padding: 10px

      div
        label
          font-size: 14px !important
          font-weight: 600
          color: #555555

  .filter-search
    width: 300px
    height: 40px
    border-radius: 4px
    padding: 10px
    background-color: #fff

  .btn_wrap
    margin-top: 15px

    button
      width: auto
      padding: 5px 20px
      color: #fff
      text-transform: uppercase
      cursor: pointer
      border-radius: 3px
      &:focus
        outline: none

      &:nth-child(1)
        background-color: #ACC3CF

      &:nth-child(2)
        background-color: var(--v-primary-base)
</style>


